<template>
  <div>
    <div v-if="activity" class="activity-details-container border-container pt-50 select-scroll ">
      <div id="main">
        <div class="container">
          <div class="activity_heading">
            <div class="row">
              <div class="col-3 col-md-2 pl-0 pr-0 arrow-padding">
                <div class="agreement" @click="goToPreviousQuestion()">
                  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="25" fill="none" viewBox="0 0 15 25">
                    <path fill="var(--primary)" fill-rule="evenodd" d="M14.773 2.344L12.43 0 0 12.43l12.43 12.43 2.343-2.345L4.688 12.43 14.773 2.344z" clip-rule="evenodd" />
                  </svg>
                </div>
              </div>
              <div class="col-6 col-md-8 text-center pb-10 p-0">
                <h2>{{ title }}</h2>
              </div>
              <div data-toggle="modal" data-target="#activity_cancel_Modal" class="col-3 col-md-2 text-right pl-0 pr-0 pt-7 activity-modal-btn">
                <h5 class="cursor_pointer" v-translate:label_cancel="lang">
                  CANCEL
                </h5>
              </div>
            </div>
          </div>
          <Schedule v-if="activeScreen == 'schedule'" :key="'schedule'" :lang="lang" :activity="visitInfo" @updateActiveScreen="updateActiveScreen"></Schedule>
          <ScheduleOptions v-else-if="activeScreen == 'videocall'" :key="'videocall'" :lang="lang" :activity="visitInfo" :reschedule="isToReschedule" :availableSlots="availableSlots" :extendedDates="extendedDates" :isAppointmentScheduled="isAppointmentScheduled" @updateActiveScreen="confirmAppointment"></ScheduleOptions>
          <SchedulePhone v-else-if="activeScreen == 'phonecall'" :key="'phonecall'" :lang="lang" :activity="visitInfo" :reschedule="isToReschedule" :availableSlots="availableSlots" :extendedDates="extendedDates" :isAppointmentScheduled="isAppointmentScheduled" @updateActiveScreen="confirmAppointment"></SchedulePhone>
          <ScheduleHomevisit v-else-if="activeScreen == 'homevisit'" :key="'homevisit'" :lang="lang" :activity="visitInfo" :reschedule="isToReschedule" :availableSlots="availableSlots" :extendedDates="extendedDates" :isAppointmentScheduled="isAppointmentScheduled" @updateActiveScreen="confirmAppointment"></ScheduleHomevisit>
          <ScheduleOfficevisit v-else-if="activeScreen == 'officevisit'" :key="'officevisit'" :lang="lang" :activity="visitInfo" :reschedule="isToReschedule" :availableSlots="availableSlots" :extendedDates="extendedDates" :isAppointmentScheduled="isAppointmentScheduled" @updateActiveScreen="confirmAppointment"></ScheduleOfficevisit>
        </div>
      </div>
    </div>
    <!-- activity modal start -->
    <div class="activityCancelModel">
      <div ref="activityCancelModel" class="modal fade" id="activity_cancel_Modal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
        <div class="modal-dialog modal-lg m-10" role="document">
          <div class="modal-content">
            <div class="modal-body modal-padding p-28">
              <div class="verification text-center">
                <h2 class="p-0 m-0" v-translate:ml_are_you_sure="lang">
                  Are you sure?
                </h2>
              </div>
              <div class="d-flex justify-content-end pt-50 ml-30 mr-30">
                <div class="col-6 col-md-6 pl-0">
                  <button data-dismiss="modal" class="btn leavestudy" v-translate:CANCEL_BUTTON_TITLE="lang">
                    Cancel
                  </button>
                </div>
                <div class="col-6 col-md-6 pr-0 discard-btn">
                  <button class="btn leave_study_cntue" data-dismiss="modal" @click="goToPreviousQuestion(true)" v-translate:rsb_discard_results="lang">
                    Discard Results
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <!-- activity modal end -->
  </div>
</template>

<script>
import moment from "moment";
import nprogress from "nprogress";
import { mapGetters } from "vuex";
import Schedule from "@/components/participant-portal/telehealth/schedule";
import ScheduleOptions from "@/components/participant-portal/telehealth/schedule-options";
import SchedulePhone from "@/components/participant-portal/telehealth/schedule-phone";
import ScheduleHomevisit from "@/components/participant-portal/telehealth/schedule-homevisit";
import ScheduleOfficevisit from "@/components/participant-portal/telehealth/schedule-officevisit";
import { Widget, Telehealth, ParticipantPortal } from "@/components/services/participant-service";
export default {
  name: "telehealth",
  components: {
    Schedule,
    ScheduleOptions,
    SchedulePhone,
    ScheduleHomevisit,
    ScheduleOfficevisit
  },
  props: [],
  data() {
    return {
      widget: new Widget(),
      telehealth: new Telehealth(),
      portal: new ParticipantPortal(),

      screens: [
        { name: "schedule", isActive: true },
        { name: "videocall", isActive: false },
        { name: "phonecall", isActive: false },
        { name: "homevisit", isActive: false },
        { name: "officevisit", isActive: false }
      ],
      activeScreen: "schedule",
      title: null,
      activity: null,
      visitInfo: null,
      visitType: null,
      appoinmentDetails: {},
      availableSlots: [],
      extendedDates: [],
      isToReschedule: false,
      rescheduleStartEndDate: null,
      appointmentId: "",
      isAppointmentScheduled: false,
      isToConfirmAppointment: false
    };
  },
  created() {
    this.activity = this.$route.params.activity;
    this.isToReschedule = !!(Object.keys(this.$route.params).includes("type") && this.$route.params.type == "reschedule");
    this.setTitle("th_schedule_your_visit");
    if (this.activity && this.activity.taskId !== undefined && this.activity.taskId !== null) {
      nprogress.start();
      this.getVistTypes(this.activity.taskId);
    }
    if (this.$route.params.notification !== null) {
      this.$root.$emit("notification-activity-loaded", this.$route.params.notification);
    }
  },
  computed: {
    ...mapGetters(["participant"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },
    language() {
      return this.$store.getters.getParticipantsPortalLanguages;
    },
    adherance() {
      return this.$store.getters.getParticipantSelectedActivity;
    },
    study() {
      return this.$store.getters.getParticipantsPortalStudyData;
    }
  },
  mounted() {
    this.setTitle("th_schedule_your_visit");
    this.isToReschedule = !!(Object.keys(this.$route.params).includes("type") && this.$route.params.type == "reschedule");
    if (this.activity && this.activity.taskId !== undefined && this.activity.taskId !== null) {
      nprogress.start();
      this.getVistTypes(this.activity.taskId);
    }
    if (this.$route.params.notification !== null) {
      this.$root.$emit("notification-activity-loaded", this.$route.params.notification);
    }
  },
  methods: {
    setTitle(key) {
      if (key) {
        this.title = this.widget.translate(key, "Schedule Your Visit");
      } else {
        this.title = this.widget.translate("th_schedule_your_visit", "Schedule Your Visit");
      }
    },
    getLocalOffset() {
      const offset = new Date().getTimezoneOffset();

      const o = Math.abs(offset);
      return (offset < 0 ? "+" : "-") + ("00" + Math.floor(o / 60)).slice(-2) + ":" + ("00" + (o % 60)).slice(-2);
    },
    goToPreviousQuestion(discard) {
      if (this.activeScreen != "schedule" && !discard) {
        this.activeScreen = "schedule";
        this.getVistTypes(this.activity.taskId);
        this.setTitle(false);
      } else {
        this.$router.push({ name: "participants-portal-activity-list" });
      }
    },
    getVistTypes(taskId) {
      this.telehealth
        .getScheduleVisitTypes(taskId)
        .then(res => {
          if (this.isToReschedule) {
            const date = new Date(this.activity.callTime);
            const m = moment(date);
            this.activity.visitType = res.visitType;
            this.visitInfo = Object.assign(res, this.activity);
            this.rescheduleStartEndDate = m.format("YYYY-MM-DD");
          } else {
            this.visitInfo = res;
          }
          nprogress.done();
        })
        .catch(error => {
          nprogress.done();
          const message = this.widget.translate(error, "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    updateActiveScreen(keyOld) {
      let key = keyOld;
      if (typeof key === "object") {
        if (Object.keys(key).includes("flagChild")) {
          this[key.flagKey][key.flagChild] = key.flagValue;
        } else {
          this[key.flagKey] = key.flagValue;
        }
        key = key.key;
      } else {
        this.getOptions(key);
      }

      this.screens = this.screens.map(e => {
        e.isActive = false;
        return e;
      });
      const newScreen = this.screens.find(e => e.name == key);
      if (newScreen) {
        this.activeScreen = newScreen.name;
        this.screens = this.screens.map(e => {
          e.isActive = e.name == key;
          return e;
        });
      }
    },
    getOptions(type) {
      const that = this;
      const stringKeys = {
        videocall: "label_schedulecall",
        officevisit: "schedule_office_visit",
        homevisit: "label_schedule_your_home_visit",
        phonecall: "label_schedule_your_phone_call"
      };
      this.setTitle(stringKeys[type]);
      nprogress.start();
      const registrationDate = this.portal.getUserDate();
      const startDate = registrationDate
        .clone()
        .add(this.adherance.scheduleDay, "days")
        .format("YYYY-MM-DD");
      const endDate = registrationDate
        .clone()
        .add(this.adherance.endDay - 1, "days")
        .format("YYYY-MM-DD");
      this.appoinmentDetails.visitType = type;
      const params = {
        studyId: this.participant.studyId,
        siteId: this.participant.siteId,
        participantId: this.participant.pid,
        startDate: startDate,
        endDate: endDate,
        visitId: this.activity.taskId,
        timeZone: moment.tz.guess()
      };
      this.$api.getParticipantAppointmentSlots(this.participant.siteId, params).then(
        res => {
          that.availableSlots = res.data.availableSlots.filter(item => {
            return !!(moment(item.date, "YYYY-MM-DD").isSameOrAfter(startDate) && moment(item.date, "YYYY-MM-DD").isSameOrBefore(endDate));
          });
          that.availableSlots = [...that.availableSlots, ...res.data.extendedDates];
          that.extendedDates = res.data.extendedDates;
          that.visitType = that.telehealth.getVisitType(type);
          nprogress.done();
        },
        () => {
          nprogress.done();
          const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        }
      );
    },
    confirmAppointment(data) {
      const currentDay = this.portal.getCurrentDay().toString();
      const date = new Date(data.time.slotStartTime);
      const dateUTC = date.toISOString();
      const studyVersionId = this.participant.myStudyVersionId ? this.participant.myStudyVersionId : this.participant.studyVersionId;
      const postData = {
        activitySchedulingMode: "schedule",
        appointementTimeLocal: dateUTC.replace("Z", this.getLocalOffset()),
        appointementTimeOffset: this.getLocalOffset(),
        appointementTimeUtc: dateUTC.replace("T", " ").replace("Z", ""),
        appointmentDate: date.getTime(),
        deviceId: this.portal.getDevice(),
        endTime: data.time.slotEndTime,
        id: "",
        participantId: this.participant.pid,
        piAvailabilityId: data.time.availabilityId,
        piAvailabilitySlot: data.time.appointmentSlotId,
        piId: data.date.piId,
        siteId: data.time.siteId,
        startTime: data.time.slotStartTime,
        status: "",
        studyId: this.portal.getStudy(),
        studyVersionId: studyVersionId,
        taskInstanceUUID: this.activity.taskInstanceId,
        type: "Scheduled",
        visitId: this.visitInfo.id,
        visitName: this.visitInfo.title,
        visitType: this.visitType,
        participantCurrentDay: currentDay
      };

      if (this.visitType == "Homevisit") {
        postData.participantAppointmentContact = data.address;
      } else if (this.visitType == "In-person") {
      } else if (this.visitType == "Phonecall") {
        postData.participantAppointmentContact = data.address;
      } else if (this.visitType == "Videocall") {
        postData.visitType = "Telehealth";
      }

      const scheduleQueryParam = {
        participantId: this.participant.pid,
        isScheduledOutsideCompletionWindow: false
      };

      /** If Appointment is to reschedule */
      if (this.isToReschedule) {
        scheduleQueryParam["isReschedule"] = true;
        scheduleQueryParam["rescheduleId"] = this.activity && this.activity.appointmentId;
      }
      /** end of Appointment is to reschedule */
      this.$api.confirmParticipantAppointmentSlot(data.time.siteId, scheduleQueryParam, postData).then(
        () => {
          if (this.$route.params.notification !== null) {
            this.$root.$emit("readNotification", this.$route.params.notification);
          }
          if (!this.isToReschedule) {
            this.updateCompletedCount();
          }
          this.updateResponseData();
        },
        () => {
          nprogress.done();
          const message = this.widget.translate("already_booked_slot_alert_message", "Selected appointment time is no longer available. Please pick another slot.");
          if (message) {
            this.$toastr.error(message);
          }
        }
      );
    },
    updateResponseData() {
      const completedTime = new Date();
      const studyVersionId = this.participant.myStudyVersionId ? this.participant.myStudyVersionId : this.participant.studyVersionId;
      const postData = {
        activitySchedulingMode: "schedule",
        allowMultiple: this.adherance && this.adherance.allowMultiple,
        completed: true,
        completedDateTime: completedTime.getTime(),
        dailyCompletionCount: this.adherance && this.adherance.completedCount + 1,
        endDay: this.adherance.endDay,
        participantId: this.participant.pid,
        scheduleCount: this.adherance.scheduledCount,
        scheduleDay: this.adherance.scheduleDay,
        scheduleId: this.adherance.scheduleId,
        sequence: this.adherance.sequence,
        startDay: this.adherance.startDay,
        studyVersionId: studyVersionId,
        taskClassName: "telehealth",
        taskFileName: this.adherance.taskId,
        taskId: this.adherance.taskId,
        taskInstanceUUID: this.activity.taskInstanceId,
        taskTitle: this.adherance.taskTitle,
        taskType: this.adherance.taskType,
        taskStartDate: 0,
        taskEndDate: 0,
        scheduledDate: this.adherance.scheduledDate
      };

      this.$api
        .updateParticipantComplianceAdharance(
          {
            participantId: this.participant.pid,
            studyId: this.portal.getStudy(),
            deviceId: this.portal.getDevice(),
            siteId: this.study.sitesInfo[0].id,
            siteName: this.study.sitesInfo[0].name,
            deviceType: "web"
          },
          { taskSchedules: [postData] }
        )
        .then(() => {
          nprogress.done();
          this.$root.$emit("activityCompleted", postData.taskInstanceUUID);
          this.$router.push({
            name: "participants-portal-activities",
            params: { languageId: this.portal.getLanguage() }
          });
        })
        .catch(() => {
          nprogress.done();
          const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    updateCompletedCount() {
      const data = [];
      const studyVersionId = this.participant.myStudyVersionId ? this.participant.myStudyVersionId : this.participant.studyVersionId;
      const adherance = Object.assign({}, this.adherance);
      adherance.siteId = this.study.sitesInfo[0].id;
      adherance.siteName = this.study.sitesInfo[0].name;
      adherance.completedCount = 1;
      adherance.scheduledCount = this.adherance.scheduledCount == 0 ? 1 : this.adherance.scheduledCount;
      adherance["deviceId"] = this.portal.getDevice();
      adherance["studyVersionId"] = studyVersionId;
      delete adherance.taskTitle;
      data.push(adherance);
      this.$api
        .updateParticipantAdharance({ participantId: this.participant.pid, language: this.languageId }, { results: data })
        .then(() => {})
        .catch(() => {
          const message = this.widget.translate("NETWORK_ERROR_MSG", "Network error, please try again later.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    }
  }
};
</script>
